import script from "./CertificateTableActions.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateTableActions.vue?vue&type=script&setup=true&lang=js"

import "./CertificateTableActions.vue?vue&type=style&index=0&id=c4fa773a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4fa773a"]])

export default __exports__